import { useState } from 'react';
import GuideBeraterChat, { type GuideBeraterStart } from './GuideBeraterChat';

/** Warm the assigned chat while the stage is read; pause polling when folded. */
export default function GuideBeraterSidebar({ buehneId, offen: vonAussen, onOffenChange, start }: { buehneId: string; start?: GuideBeraterStart; offen?: boolean; onOffenChange?: (offen: boolean) => void }) {
  const [lokalOffen, setLokalOffen] = useState(false);
  const offen = vonAussen ?? lokalOffen;
  const setOffen = (an: boolean) => { setLokalOffen(an); onOffenChange?.(an); };
  return <aside aria-label="Berater der Bühne" data-ai-id="guide-berater-sidebar" data-open={offen}
    style={{ position: 'relative', zIndex: 10, flex: '0 0 auto', width: offen ? 'min(420px, 40vw)' : 32,
      minHeight: 0, overflow: 'hidden', borderLeft: '1px solid var(--tn-border)', background: 'var(--tn-bg-dark)' }}>
    <button aria-expanded={offen} aria-controls="guide-berater-sidebar-chat"
      onClick={() => { setOffen(!offen); }}
      title={offen ? 'Berater-Chat einklappen' : 'Berater-Chat öffnen'}
      style={{ position: 'absolute', top: 8, left: 0, width: 30, padding: '10px 5px', writingMode: 'vertical-rl',
        cursor: 'pointer', color: 'var(--tn-blue)', background: 'var(--tn-bg)', border: '1px solid var(--tn-border)', borderRadius: 5 }}>
      {offen ? '›' : '‹'} Berater
    </button>
    <div id="guide-berater-sidebar-chat" aria-hidden={!offen}
      style={{ position: 'absolute', top: 0, bottom: 0, left: 32, width: 'calc(min(420px, 40vw) - 32px)',
        visibility: offen ? 'visible' : 'hidden', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      <GuideBeraterChat key={buehneId} buehneId={buehneId} visible={offen} start={start} />
    </div>
  </aside>;
}
